import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import GTMProjectDetail from "./GTMProjectDetail";
import GTMProjectsPage from "./GTMProjectsPage";

export const ReleaseContext = createContext(null);

const ReleaseRoutes = () => {
  return (
    <Routes>
      <Route index element={<GTMProjectsPage />} />
      <Route path=":id" element={<GTMProjectDetail />} />
    </Routes>
  );
};

export default ReleaseRoutes;
